<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Password Blacklist Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.blacklistedPassword }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Password Blacklist<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="passBlacklistDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.passBlacklistFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 v-if="newPassBlacklist">
                  <v-text-field v-model="passBlacklistForm.blacklistedPassword" :label="labels.blacklistedPassword" :error-messages="errors.collect('blacklistedPassword')" data-vv-name="blacklistedPassword" :data-vv-as="labels.blacklistedPassword" v-validate="'required|param|max:128'"></v-text-field>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-text-field v-model="passBlacklistForm.blacklistedPassword" :label="labels.blacklistedPassword" :error-messages="errors.collect('blacklistedPassword')" v-validate="'required|param|max:128'" data-vv-name="blacklistedPassword" :data-vv-as="labels.blacklistedPassword"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Password Blacklist? ({{deletePassBlacklist}})
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
// import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Blacklisted Password', value: 'blacklistedPassword' },
        TableConst.tableActionHeader
      ],
      labels: {
        passBlacklistFormTitle: 'Password Blacklist Details',
        blacklistedPassword: 'Blacklisted Password*'
      },
      passBlacklistForm: {
        blacklistedPassword: null
      },
      filters: {
        blacklistedPassword: null
      },
      passBlacklistDialog: null,
      newPassBlacklist: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedPassBlacklist: undefined,
      deletePassBlacklist: ''
    }
  },
  computed: {
    passBlacklist() {
      return this.$store.state.adminUser.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.passBlacklist.getPasswordBlacklists
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((passwordBlackList) => {
              const convertPassBlacklist = {
                blacklistedPassword: passwordBlackList.blacklistedPassword
              }
              this.items.push(convertPassBlacklist)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      this.init()
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPassBlacklist = data
        this.deletePassBlacklist = data.blacklistedPassword
      }
    },
    async doRemove() {
      const apiURI = this.passBlacklist.deletePassBlacklist
      if (apiURI) {
        this.loading = true
        // const expand = {
        //   blacklistedPassword: this.selectedPassBlacklist.blacklistedPassword
        // }
        this.passBlacklistForm.blacklistedPassword = this.selectedPassBlacklist.blacklistedPassword
        try {
          // const result = await this.$http.post(expandURI(apiURI, expand))
          const result = await this.$http.post(apiURI, this.passBlacklistForm)
          this.notify(result.data)
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newPassBlacklist = true
      this.passBlacklistDialog = true
    },
    doClose() {
      this.newPassBlacklist = false
      this.passBlacklistDialog = false
      this.passBlacklistForm.blacklistedPassword = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPassBlacklist) {
            this.doCreate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.passBlacklist.createPasswordBlacklist
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.passBlacklistForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
